export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const API_TIMEOUT = parseInt(process.env.REACT_APP_API_TIMEOUT) || 10000;
export const ENDPOINTS = {
  AUTH: {
    SIGNUP: '/auth/signup',
    LOGIN: '/auth/token',
    PASS_Login: '/auth/token/password'
  },
  CHATS: {
    CREATE: '/chats/create_chats',
    GET_ALL: '/chats/get_chats',
    UPDATE: '/chats/update_chats',
    DELETE: '/chats/delete_chats',
  },
  AI: {
    GRAMMAR_CHECK: '/ai/v1/grammar-check',
  }
};